/**
 * Compact line timestamp for support chat bubbles — not prominent.
 * Same calendar day → time only; older → short date + time (locale-aware).
 */
export function formatChatTimestamp(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const now = new Date();
  const sameDay =
    d.getDate() === now.getDate() &&
    d.getMonth() === now.getMonth() &&
    d.getFullYear() === now.getFullYear();
  const timeStr = d.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' });
  if (sameDay) return timeStr;
  const dateStr =
    d.getFullYear() === now.getFullYear()
      ? d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' })
      : d.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: '2-digit' });
  return `${dateStr} · ${timeStr}`;
}
